<template>
  <div>
    <div class="hvh-flex space-between pl-4 mb-3" v-if="!showSearch">
      <h2 class="pt-2">{{ text }} - {{ bottomText.split(' ').first() }}</h2>
      <div>
        <v-menu v-model="menu" bottom left origin="top right" style="z-index: 1001">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="my-1 mx-2" flat icon v-bind="attrs" v-on="on" @click.stop.prevent>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card class="py-1">
            <v-list class="pb-0">
              <v-list-tile class="search" @click="(showSearch = true), (menu = false)">
                <v-flex class="icon">
                  <v-btn class="button" flat icon>
                    <v-icon medium>mdi-magnify</v-icon>
                  </v-btn>
                </v-flex>
                <v-list-tile-title>Search</v-list-tile-title>
              </v-list-tile>
            </v-list>

            <v-divider></v-divider>
            <v-list class="pb-0">
              <v-list-tile>
                <v-list-tile-sub-title>Sort Order</v-list-tile-sub-title>
              </v-list-tile>
            </v-list>

            <v-list class="py-0" v-for="(count, ind) in countOptions" :key="ind">
              <v-list-tile @click="setCountBy(count.prop)">
                <v-flex style="min-width: 40px">
                  <v-icon v-if="menuOptions.countBy === count.prop">mdi-check</v-icon>
                </v-flex>
                <v-list-tile-title>{{ count.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </div>
    <SearchableHorizontalBarchartFilter
      :text="text"
      :data="data"
      :options="options"
      nameField="name"
      :valueField="menuOptions.countBy"
      :isChecked="isChecked"
      :showSearch.sync="showSearch"
      :showLoader="isFiltering"
      :bottomText="bottomText"
      @checked-changed="$emit('checked-changed', $event)"
    />
  </div>
</template>
  
<script>
import { customNumberFormat, Debouncer, hashCode } from '../../../../libraries/common';
import SearchableHorizontalBarchartFilter from '../../../analysis/SearchableHorizontalBarchartFilter.vue';
export default {
  components: { SearchableHorizontalBarchartFilter, },
  props: ['data', 'filterObject', 'text', 'isChecked', 'isFiltering', 'menuOptions',],
  data() {
    return {
      displayedBarChartData: 10,
      scrollBarValue: 0,
      debouncer: new Debouncer(2000),
      search: {},
      showSearch: false,
      menu: false,
      skipNextFilter: false,
      countOptions: [
        { prop: 'totalPlanPay', text: 'Total Price' },
        { prop: 'averagePlanPay', text: 'Average Price' },
      ],
      options: {
        tooltip: {
          formatter: (params) => {
            return '<div style="max-width:400px;white-space:pre-wrap;">' +
              params.name + '<br>' +
              this.countOptions.map(f => `${f.text}: $${customNumberFormat(params.data.data[f.prop])}<br>`).join('') +
              '<div>';
          }
        },
      },
    }
  },
  computed: {
    bottomText() {
      return this.countOptions.find(f => f.prop === this.menuOptions.countBy)?.text;
    },
    filterHash() {
      return hashCode(this.filterObject || {});
    },
  },
  methods: {
    setCountBy(countBy) {
      this.$emit('update:menu-options', { ...this.menuOptions, countBy });
    },
  },
  watch: {
    filterHash() {
      if (!this.skipNextFilter) {
        this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
      } else {
        this.skipNextFilter = false;
      }
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  }
}
</script>

<style lang="scss" scoped>
.search {
  min-width: 150px;
  .icon {
    min-width: 40px;
    .button {
      margin-left: -6px;
    }
  }
}
</style>